/** Vordefinierte Farben für Platzkategorien und Planer-Balken (wie Montageplanung). */
export const PITCH_CATEGORY_COLORS: Array<{ value: string; label: string }> = [
  { value: "#0a84ff", label: "Blau" },
  { value: "#30b0c7", label: "Türkis" },
  { value: "#34c759", label: "Grün" },
  { value: "#ffd60a", label: "Gelb" },
  { value: "#ff9f0a", label: "Orange" },
  { value: "#ff375f", label: "Rot" },
  { value: "#bf5af2", label: "Violett" },
  { value: "#8e8e93", label: "Grau" },
];

export const DEFAULT_PITCH_CATEGORY_COLOR = PITCH_CATEGORY_COLORS[0]!.value;

export function categoryColorOrDefault(color: string | null | undefined): string {
  return color?.trim() || DEFAULT_PITCH_CATEGORY_COLOR;
}
